"use strict";
exports.__esModule = true;
var angular = require("angular");
require('../comment-box-form.css');
var probabilityFormController = /** @class */ (function () {
    function probabilityFormController() {
    }
    return probabilityFormController;
}());
var probabilityFormDisplayController = /** @class */ (function () {
    function probabilityFormDisplayController() {
        var _this = this;
        this.$onChanges = function () {
            var msg = [];
            if (_this.commentDecodedMsg) {
                var _a = _this.commentDecodedMsg, keysOrder = _a.keysOrder, form_1 = _a.form;
                (keysOrder || []).forEach(function (key) {
                    if (form_1[key].comment)
                        msg.push(key + ': ' + form_1[key].comment);
                });
            }
            _this.decodedMsg = msg;
        };
    }
    return probabilityFormDisplayController;
}());
angular.module('smartorg.r6.cmpts.probabilityForm', []).component("probabilityForm", {
    template: require("./probability-form.component.html"),
    controller: probabilityFormController,
    bindings: {
        currentComment: '='
    }
}).component("probabilityFormDisplay", {
    template: require("./probability-form.display.html"),
    controller: probabilityFormDisplayController,
    bindings: {
        commentDecodedMsg: '<'
    }
});
module.exports = 'smartorg.r6.cmpts.probabilityForm';
//# sourceMappingURL=probability-form.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/probability-form/probability-form.component.js